import React, { ReactElement } from 'react';
import { defineMessages, useIntl } from 'react-intl';
import styles from './optional-signature-frame.module.css';

const messages = defineMessages({
  digitallySignedBy: {
    id: '',
    description: 'Label for the optional signature frame',
    defaultMessage: 'Digitally signed by:',
  },
});

export const OptionalSignatureFrame = ({
  children,
  isEnabled,
  scale,
}: {
  children: ReactElement;
  isEnabled: boolean;
  scale: number;
}) => {
  const intl = useIntl();
  return isEnabled ? (
    <>
      <div className={styles.frame} style={{ '--scale': scale }}>
        <div className={styles.frameTopLeft}></div>
        <div className={styles.frameLabel}>
          {intl.formatMessage(messages.digitallySignedBy)}
        </div>
        <div className={styles.frameTopRight}></div>
        <div className={styles.frameRemaining}></div>
      </div>
      {children}
    </>
  ) : (
    children
  );
};
